<template>
    <div class="container vh-100 d-flex flex-column justify-content-center align-items-center px-4">
        <div class="col-12 text-center">
            <!-- Logo mobile -->
            <router-link to="/">
                <img src="@/assets/images/logo_black.png" alt="Sheltr Logo" class="logo" />
            </router-link>
        </div>
        <div class="col-12 col-md-8">
            <div class="login__content d-flex flex-column justify-content-center pt-5 col-12 col-md-8">
                <p class="fs-26 fw-medium mb-4"></p>
                <div class="mb-3">
                    <label class="fs-16 pb-2 fw-medium">Email address</label>
                    <input type="email" class="login-content__input form-control" v-model="loginModel.email"
                        @blur="v$.loginModel.email.$touch" />
                    <div v-if="v$.loginModel.email.$dirty">
                        <p class="form__error" v-if="v$.loginModel.email.email.$invalid">Please enter a
                            valid email address </p>
                        <p class="form__error" v-if="v$.loginModel.email.required.$invalid">This field
                            is required</p>
                    </div>

                </div>
                <div class="mb-3">
                    <label class="fs-16 pb-2 fw-medium">Password</label>
                    <input type="password" class=" form-control" v-model="loginModel.password"
                        @blur="v$.loginModel.password.$touch" />
                    <div v-if="v$.loginModel.password.$dirty">
                        <p class="d-inline form__error" v-if="v$.loginModel.password.minLength.$invalid">Your
                            password must be at
                            least 8 characters long </p>
                        <p class="d-inline form__error" v-if="v$.loginModel.password.required.$invalid">
                            This field is required</p>
                    </div>

                    <router-link to="/forgotpassword" class="d-none mt-2 d-md-inline float-end fw-600">Forgot
                        password?</router-link>
                </div>
                <div class="form-group mt-3 mt-sm-0">
                    <div class="conv-checkbox">
                        <input type="checkbox" name="RememberMe" id="rememberme" v-model="loginModel.rememberMe" />
                        <label for="rememberme">Keep me signed in</label>
                    </div>
                </div>
                <div class="form-group mt-3">
                    <div class="row">
                        <div class="col">
                            <button class="btn btn-cta btn-cta--medium btn-block fs-16 w-100" @click="login">Log
                                in</button>
                        </div>
                        <div class="conv-footer col-12 mt-3 mt-md-2">
                            <p class="d-md-none fw-400 mb-4"> Forgot password? <router-link to="/forgotpassword"
                                    class="fw-400">Click here to
                                    reset</router-link></p>
                            <p class="create-account text-center fs-6"> Not a member yet? <router-link
                                    to="/signup/subscriber" class="fw-400">Create an account</router-link></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength, email, maxLength, minValue } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import config from '@/utilities/config';
import http from '@/utilities/http';
import { useAppStore } from '@/stores/appstore';
import toast from 'toastr';
import { dump } from 'piexifjs';
export default {
    data() {
        return {
            loginModel: {
                email: undefined,
                password: undefined,
                rememberMe: undefined
            },
            passwordVisible: false,
            errors: undefined,
            userInfo: {
                email: '',
                firstname: ''
            },
            loginResult: {},
            store: useAppStore()
        }
    },

    setup() {
        return {
            v$: useVuelidate()
        }
    },

    validations() {
        return {
            loginModel: {
                email: {
                    required,
                    email,
                    $autoDirty: true
                },
                password: {
                    required,
                    minLength: minLength(8),
                    $autoDirty: true

                }
            },
        }
    },
    methods: {
        async login() {
            try {
                if (!this.v$.$invalid) {
                    const requestUrl = config.LoginUrl;
                    const response = await http.post(requestUrl, this.loginModel);

                    this.loginResult = response.result;
                    this.$toast.success('Login successful');
                    this.store.logIn(response.result);
                    if (response.result.user.userType === 'Admin' || response.result.user.userType === 'Financier') {
                        this.$router.push({ name: 'dashboard' });
                    }
                    this.$router.push({ name: 'Home' });

                    //this.$router.go(-1); //Todo: Implement proper redirection
                }
                else {
                    this.$toast.error('Please fill in the correct login details');
                }
            } catch (e) {
                console.log(e);
                
                // Check if error is due to unverified email
                const errorMessage = e?.Message || e?.message || e?.response?.data?.Message || '';
                
                if (errorMessage.toLowerCase().includes('check your email') || 
                    errorMessage.toLowerCase().includes('confirm your account') ||
                    errorMessage.toLowerCase().includes('email not confirmed')) {
                    // Redirect to OTP verification page
                    this.$toast.error('Please verify your email address before logging in');
                    setTimeout(() => {
                        this.$router.push({
                            name: 'otp-verification',
                            params: { email: encodeURIComponent(this.loginModel.email) }
                        });
                    }, 1500);
                } else {
                    this.$toast.error(`An unknown error occured.(${errorMessage || e.message})`);
                }

            }
        },
    },

}
</script>

<style scoped>
.logo {
    width: 120px;
}

@media (min-width: 1200px) {
    .login__content {
        margin-top: 88px;
    }
}

@media (min-width: 768px) {
    .login__content {
        max-width: 376px;
        margin: auto;
        margin-top: 48px;

    }
}
</style>